import React from "react";
import { List } from "semantic-ui-react";
import ItemCurso from "../ItemCurso";

const ListarCurso = (props) => {
  return (
    <List divided inverted relaxed verticalAlign="middle">
      {props.cursos
        .filter((v) => v.id == props.currentCurso.id)
        .map((v) => (
          <ItemCurso
            curso={v}
            currentCurso={props.currentCurso}
            setCurrentCurso={props.setCurrentCurso}
            setSearchCurso={props.setSearchCurso}
          />
        ))}
      {props.cursos
        .filter(
          (v) =>
            props.searchCurso &&
            (v.titulo.toLowerCase().indexOf(props.searchCurso.toLowerCase()) >
              -1 ||
              v.id == props.searchCurso) &&
            v.id != props.currentCurso.id
        )
        .sort((a, b) => {
          if (a.id.toString() === props.searchCurso) {
            return -1;
          }

          if (b.id.toString() === props.searchCurso) {
            return 1;
          }

          return 0;
        })
        .map((v) => (
          <ItemCurso
            curso={v}
            currentCurso={props.currentCurso}
            setCurrentCurso={props.setCurrentCurso}
            setSearchCurso={props.setSearchCurso}
          />
        ))}
    </List>
  );
};

export default ListarCurso;
